var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 204 210"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#medium_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5D7C8",
    d: "M93.27 201.66c-47.832-4.185-83.324-45.824-79.203-92.921l5.432-62.088c.594-6.793 5.008-12.662 11.394-15.15L102.52 3.59a18.18 18.18 0 0 1 16.034 1.402l65.692 39.924c5.857 3.56 9.185 10.106 8.591 16.899l-5.432 62.088c-4.121 47.098-46.304 81.94-94.136 77.756"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5D7C8",
    fillRule: "evenodd",
    d: "M20.135 108.212c-3.882 44.378 29.124 83.574 73.657 87.47s83.844-28.973 87.727-73.351l5.388-61.583a11.99 11.99 0 0 0-5.684-11.256L115.545 9.146a12.11 12.11 0 0 0-10.784-.944L33.075 36.53a11.99 11.99 0 0 0-7.552 10.099zm87.424-73.126c2.487.218 4.679-1.612 4.896-4.087s-1.625-4.658-4.112-4.875c-2.487-.218-4.679 1.612-4.896 4.087s1.624 4.657 4.112 4.875",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002003",
    fillRule: "evenodd",
    d: "M91.46 178.56c19.288 2.933 37.932-2.093 52.674-12.651a1.002 1.002 0 0 1 1.167 1.628c-15.145 10.847-34.31 16.015-54.135 13-16.48-2.508-30.89-10.289-41.801-21.393a1 1 0 1 1 1.424-1.401c10.618 10.807 24.637 18.376 40.671 20.817",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "medium_svg__a",
    width: 211.164,
    height: 231.649,
    x: -2.259,
    y: -13.649,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_976_71442"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_976_71442",
    result: "effect2_dropShadow_976_71442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_976_71442",
    result: "shape"
  })))));
};
export default SvgMedium;